export default {
	// 以下のように使用する
	// <PaginationModule :pagination="pagination" @get-page="getPage(ここにfetchFunction, [], $event)" />
	data() {
		return {
			pagination: {
				count: null,
				current: 1,
				limit_value: null,
				next: null,
				pages: null,
				previous: null,
			},
		}
	},
	components: {
		PaginationModule: () => import("../view/shared/PaginationModule.vue"),
	},
	methods: {
		getPage(fetchFunction, args = [], page, pagePush = true, pageScroll = true) {
			// 引数のfetchFunctionの関数を呼び出す
			fetchFunction(...args, page)
			const q = this.q ? this.q : {}
			// routeを設定する
			if (pagePush)
				this.$router.push({
					name: this.$route.name,
					query: { page: page, ...q },
				})
			// ページをスクロールを上に
			if (pageScroll)
				window.scrollTo({
					top: 0,
					behavior: "smooth",
				})
		},
		// ページを覗くクエリ情報をthis.qに設定する
		setQuery(ignoreParams = ["page"]) {
			const query = this.$route.query
			let q = this.q
			Object.keys(this.$route.query).forEach((query_key) => {
				// ignoreParamsに含まれていないクエリ情報をthis.qに設定する
				if (query[query_key] && !ignoreParams.includes(query_key)) {
					q[query_key] = this.formatQuery(query[query_key])
				}
			})
			this.q = q
		},
		formatQuery(query) {
			if (query instanceof Array) {
				return query.map((v) => (isFinite(v) ? Number(v) : v))
			} else if (isFinite(query)) {
				return Number(query)
			} else {
				return query
			}
		},
	},
}
